import {all, takeEvery, put, call } from 'redux-saga/effects';

import actions from "./actions"
import {
    getInvoiceDetails,
    getInvoiceDetailsByAdmin,
    getInvoicesAll,
    getInvoicesAllByWorkspace, getInvoicesAllFilterMonth, getInvoicesFilterMonth
} from "../../services/invoices.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";


export function* GET_ALL_INVOICES_DATA(){
    try{
        const response: AxiosResponse<any> = yield call(getInvoicesAll);
        if(response.data){
            yield put({
                type: actions.SET_ALL_INVOICES_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_ALL_INVOICES_DATA", e); }
}

export function* GET_ALL_INVOICES_DATA_FILTER_MONTH(action:{payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getInvoicesAllFilterMonth,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_ALL_INVOICES_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_ALL_INVOICES_DATA_FILTER_MONTH", e); }
}

export function* GET_INVOICES_DATA_FILTER_MONTH(action:{payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getInvoicesFilterMonth,
          action.payload
        );
        if (response.data){
            yield put({
                type: actions.SET_ALL_INVOICES_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_INVOICES_DATA_FILTER_MONTH", e); }
}

export function* GET_ALL_INVOICES_BY_WORKSPACE_DATA(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getInvoicesAllByWorkspace,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_ALL_INVOICES_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_ALL_INVOICES_BY_WORKSPACE_DATA", e); }
}

export function* GET_INVOICES_DETAILS(action:{payload: any, type:string}){
    try{
        const { invoiceUuid, workspaceUuid } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getInvoiceDetails,
          workspaceUuid,
          invoiceUuid
        );
        if(response.data){
            yield put({
                type: actions.SET_INVOICES_DETAILS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_INVOICES_DETAILS", e); }
}

export function* GET_INVOICES_DETAILS_BY_ADMIN(action:{payload: any, type:string}){
    try{
        const { invoiceUuid } = action.payload;
        const response: AxiosResponse<any> = yield call(
          getInvoiceDetailsByAdmin,
          invoiceUuid
        );
        if(response.data){
            yield put({
                type: actions.SET_INVOICES_DETAILS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/invoices/sagas/GET_INVOICES_DETAILS_BY_ADMIN", e); }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_ALL_INVOICES_DATA, GET_ALL_INVOICES_DATA),
        takeEvery(actions.GET_ALL_INVOICES_BY_WORKSPACE_DATA, GET_ALL_INVOICES_BY_WORKSPACE_DATA),
        takeEvery(actions.GET_INVOICES_DETAILS, GET_INVOICES_DETAILS),
        takeEvery(actions.GET_INVOICES_DETAILS_BY_ADMIN, GET_INVOICES_DETAILS_BY_ADMIN),
        takeEvery(actions.GET_ALL_INVOICES_DATA_FILTER_MONTH, GET_ALL_INVOICES_DATA_FILTER_MONTH),
        takeEvery(actions.GET_INVOICES_DATA_FILTER_MONTH, GET_INVOICES_DATA_FILTER_MONTH),

    ])
}